import { FontAwesomeIcon as FAIcon } from '@fortawesome/react-fontawesome'
import { mergeSx, sxToStyle } from '@/theme/skinSx'

function sxObjectToStyle(sx) {
  if (!sx) return {}
  const merged = Array.isArray(sx) ? mergeSx(sx.filter(Boolean)) : sx
  if (typeof merged !== 'object') return {}
  const style = sxToStyle(merged)
  return Object.fromEntries(
    Object.entries(style).filter(
      ([k, v]) =>
        !k.startsWith('&') &&
        !k.startsWith('@') &&
        v != null &&
        typeof v !== 'object',
    ),
  )
}

/**
 * FontAwesome ignores MUI `sx`. Leftover conversion put font-size tokens on
 * `sx`, so icons shrank to 1em. Map sx onto `style` (call-site style wins).
 */
export function FontAwesomeIcon({ sx, style, ...props  }) {
  return <FAIcon style={{ ...sxObjectToStyle(sx), ...style }} {...props} />
}

export default FontAwesomeIcon
